import React from "react";
import styles from "./TopBar.module.scss";
import Header from "../header/Header";

const TopBar = props => (
  <header>
    <div className={styles.topbarContainer}>
      <div className={styles.siteTitle}>A NSW Government website</div>
    </div>
    <Header type={props.type} />
  </header>
);

export default TopBar;
